export enum AccountSuccessCodes {
  ACCOUNT_NICKNAME_UPDATED = 'account_nickname_updated',
  ACCOUNT_CLOSED = 'account_closed',
  ACCOUNT_OPEN_SUCCESS = 'account_open_success',
  ACCOUNT_OPEN_REQUEST_SUCCESS = 'account_open_request_success',
  MATURITY_DECISION_SUCCESS = 'maturity_decision_success',
  NOMINATED_BANK_ACCOUNT_UPDATED = 'nominated_bank_account_updated',
}
